// UserCreateModal.js
import '../../Assets/Styles/register.css';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import * as AppActions from '../../Store/Actions/App';
import * as UserActions from '../../Store/Actions/User';

import {
  validarEmail,
  validarTelefone,
  validarCPF,
  maskPhone,
  disableBodyScroll,
  enableBodyScroll,
  validarDataNascimentoMinima
} from '../../Components/Utils';


const UserCreateModal = (props) => {
  const {
    dialog,
    setDialog,
    // ações que você implementa em Store/Actions/User.js
    createUser,                // (POST) criação de usuário
    retrieveRightsByProfile,   // (GET/POST) direitos por perfil (grupo do usuário)
    setAlert, setAlertTitle, setAlertBody,
    selectCompany,
    isMasterUser,
    userRights,
    onReloadDataList
  } = props;

  const isOpen = dialog.target === 'userCreateModal' && dialog.status;

  const toast = React.useRef(null);

  // loaders
  const [saving, setSaving] = React.useState(false);
  const [loadingRights, setLoadingRights] = React.useState(false);

  // FORM: Dados da Pessoa
  const [nomeCompleto, setNomeCompleto] = React.useState('');
  const [cpf, setCpf] = React.useState('');
  const [nascimento, setNascimento] = React.useState(''); // dd/mm/aaaa (InputMask)
  const [celular, setCelular] = React.useState('');
  const [grupoPessoa, setGrupoPessoa] = React.useState(null);

  
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  
  // Define senha agora? (default = NÃO)
const [wantPasswordNow, setWantPasswordNow] = React.useState(false);

  // FORM: Dados do Usuário
  const [perfilUsuario, setPerfilUsuario] = React.useState(null); // gestão/adm/operacional/comercial
  const [email, setEmail] = React.useState('');
  const [email2, setEmail2] = React.useState('');
  const [senha, setSenha] = React.useState('');
  const [senha2, setSenha2] = React.useState('');

  // Direitos
  const [direitosDoPerfil, setDireitosDoPerfil] = React.useState([]); // carregados do perfil
  const [rightsCustom, setRightsCustom] = React.useState({
    manageAgencyUsers: false,
    seeOwnReservationsOnly: false
  });


// ADICIONE estados:
const [pessoaGruposOptions, setPessoaGruposOptions] = React.useState([]);
const [usuarioPerfisOptions, setUsuarioPerfisOptions] = React.useState([]);
const [agenciasOptions, setAgenciasOptions] = React.useState([]);

const [loadingPessoaGrupos, setLoadingPessoaGrupos] = React.useState(false);
const [loadingUsuarioPerfis, setLoadingUsuarioPerfis] = React.useState(false);
const [loadingAgencias, setLoadingAgencias] = React.useState(false);

const [loadingForm, setLoadingForm] = React.useState(true);


// estados de seleção (se já não existirem)
const [pessoaGrupo, setPessoaGrupo] = React.useState(null);
const [usuarioPerfil, setUsuarioPerfil] = React.useState(null);  


  // limpa ao fechar
  const resetAndClose = () => {

    // Reload parent list
    onReloadDataList?.();

    setSelectedCompany(null);
    setNomeCompleto('');
    setNascimento('');
    setCelular('');
    setGrupoPessoa(null);
    setPerfilUsuario(null);
    setEmail('');
    setEmail2('');
    setSenha('');
    setSenha2('');
    setDireitosDoPerfil([]);
    setRightsCustom({ manageAgencyUsers: false, seeOwnReservationsOnly: false });
    setDialog('userCreateModal', false);
    setLoadingRights(false);
    setSaving(false);
    setPessoaGrupo(null);
    setUsuarioPerfil(null);
    setPessoaGruposOptions([]);
    setUsuarioPerfisOptions([]);
    setLoadingPessoaGrupos(false);
    setLoadingUsuarioPerfis(false);
    setLoadingForm(true);

  };

  // carrega direitos do perfil ao selecionar
  React.useEffect(() => {
    const run = async () => {
      if (!usuarioPerfil) { setDireitosDoPerfil([]); return; }
      try {
        setLoadingRights(true);
        // padrão das suas actions: (data, propsHandlers)
        const resp = await retrieveRightsByProfile(
          { profileId: usuarioPerfil, selectCompany: !isMasterUser },
          {
            setRights: (arr) => setDireitosDoPerfil(Array.isArray(arr) ? arr : [])
          }
        );

        // se a action retornar algo já utilizável:
        if (resp?.success && Array.isArray(resp?.data)) {
          setDireitosDoPerfil(resp.data);
        }
      } catch (e) {
        setDireitosDoPerfil([]);
      } finally {
        setLoadingRights(false);
      }
    };
    run();
  }, [usuarioPerfil]);



// Execute when dialog opens
React.useEffect(() => {

    if (isOpen) {
        disableBodyScroll();

        // Grupo Pessoa
        setLoadingPessoaGrupos(true);
        props.retrieveDropdownPersonGroups(
            {},
            { 
            setRows: setPessoaGruposOptions, 
            setLoadingData: setLoadingPessoaGrupos 
            }
        );

        // Perfil Usuário
        setLoadingUsuarioPerfis(true);
        props.retrieveDropdownUserProfiles(
            {},
            { 
            setRows: setUsuarioPerfisOptions, 
            setLoadingData: setLoadingUsuarioPerfis 
            }
        );

        // Dropdown Agencias
        if (selectCompany) {
            setLoadingAgencias(true);
            props.retrieveDropdownAgencies(
                {},
                { 
                setRows: setAgenciasOptions, 
                setLoadingData: setLoadingAgencias 
                }
            );   
        }     

        // Simulate loading
        setTimeout(() => {
            setLoadingForm(false);
        }, 1000); // pequeno delay para melhor UX


    } else {
        enableBodyScroll();
    }
    
    // Runs when UNMOUNT component
    return () => {
        enableBodyScroll();
    };
            
},[dialog]);  

  // validações básicas (agora acumulando pendências)
  const validate = () => {
    const errors = [];

    if (selectCompany && !selectedCompany) {
    errors.push('Selecione a agência.');
    }

    if (!nomeCompleto?.trim()) {
      errors.push('Informe o nome completo.');
    }

    if (!cpf?.trim() || cpf.indexOf('_') !== -1 || !validarCPF(cpf)) {
      errors.push('Informe um CPF válido.');
    }

    if (!nascimento?.trim() || nascimento.indexOf('_') !== -1) {
      errors.push('Informe a data de nascimento.');
    } else if (!validarDataNascimentoMinima(nascimento)) {
      // a função do Utils valida a mínima/permitida
      errors.push('Data de nascimento inválida ou fora do permitido.');
    }

    if (!celular?.trim() || !validarTelefone(celular)) {
      errors.push('Informe um celular válido.');
    }

    if (!pessoaGrupo) errors.push('Selecione o Grupo da Pessoa.');
    
    if (!usuarioPerfil) errors.push('Selecione o Perfil do Usuário.');

    if (!validarEmail(email)) {
      errors.push('Informe um e-mail válido.');
    }
    if (email !== email2) {
      errors.push('Os e-mails não conferem.');
    }

    if (wantPasswordNow) {
        if (!senha || senha.length < 8) {
            errors.push('Defina uma senha com pelo menos 8 caracteres.');
        }
        if (senha !== senha2) {
            errors.push('As senhas não conferem.');
        }
    }


    return errors;
  };

  const handleSave = async () => {
    const errors = validate();
    if (errors.length > 0) {
    const body = (
        <ul>
        {errors.map((e, i) => <li key={i}>{e}</li>)}
        </ul>
    );

    setAlert(true);
    setAlertTitle('Verifique as informações');
    setAlertBody(body);
    return;
    }
    try {
      setSaving(true);

      const payload = {
        person: {
          fullName: nomeCompleto,
          cpf: cpf.replace(/\D/g, ''),    // remove pontuação/máscara
          birthDate: nascimento,          // dd/mm/aaaa
          phone: celular.replace(/\D/g,''),
          group: pessoaGrupo              // representante/funcionario/colaborador
        },
        user: {
          profile: usuarioPerfil,         // gestao/administrativo/operacional/comercial
          email,
          ...(wantPasswordNow ? { password: senha } : {}),
          sendPasswordSetupLink: !wantPasswordNow // <- backend usa isso pra disparar o e-mail com link
        },
        companyId: selectCompany ? selectedCompany : null, // se for masterUser, envia null
        selectCompany: selectCompany,
        isMasterUser: isMasterUser ? 1 : 0,
        rights: {
          fromProfile: direitosDoPerfil,  // lista carregada pelo perfil
          custom: {
            manageAgencyUsers: rightsCustom.manageAgencyUsers ? 1 : 0,
            seeOwnReservationsOnly: rightsCustom.seeOwnReservationsOnly ? 1 : 0
          }
        }
      };

      const resp = await createUser(payload, {
        onSuccess: () => {
         /* setAlert(true);
          setAlertTitle('Usuário criado!');
          setAlertBody('O usuário foi criado com sucesso.');
          resetAndClose();*/
        },
        onError: (msg) => {

         /* setAlert(true);
          setAlertTitle('Ops! Ocorreu um erro');
          setAlertBody(msg?.payload?.errorMessage || 'Não foi possível criar o usuário. Tente novamente.');*/

        }
      });

      if (resp?.success) {
        // já tratado em onSuccess acima

          setAlert(true);
          setAlertTitle('Tudo certo! Usuário criado!');
          setAlertBody('O usuário foi criado com sucesso. Enviamos um email notificando o usuário.');
          resetAndClose();        

      } else if (resp?.error) {
        // já tratado em onError acima
          setAlert(true);
          setAlertTitle('Ops! Ocorreu um erro');
          setAlertBody(resp?.payload?.errorMessage || 'Não foi possível criar o usuário. Tente novamente.');        
      }

    } catch (e) {

      setAlert(true);
      setAlertTitle('Ops! Ocorreu um problema');
      setAlertBody(e?.payload?.errorMessage || 'Não foi possível criar o usuário. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const headerTemplate = (
    <div className="flex-row align-items-center justify-start">
      <div className="flex-1">
        <h2 className="m-0" style={{fontSize:"1.2rem",margin:0}}>Novo usuário {isMasterUser ? '(Agência Master)' : ''}</h2>
      </div>
    </div>
  );

  const footerContent = (
    <div className="modalFooterButtons" style={{}}>
      <div className="modalFooterButtonsLeft" style={{height:"50px"}} />
      <div className="modalFooterButtonsRight">
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text" disabled={saving} onClick={resetAndClose} />
        <Button label={saving ? 'Salvando...' : 'Criar usuário'} icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'} onClick={handleSave} disabled={saving} />
      </div>
    </div>
  );

  return (
    <Dialog
      header={headerTemplate}
      visible={isOpen}
      style={{ width: '75vw', height: '90vh' }}
      breakpoints={{ '1360px': '95vw','960px': '90vw','641px': '100vw' }}
      onHide={resetAndClose}
      footer={footerContent}
      maximizable={!saving}
      closable={!saving}
      closeOnEscape
      key="user-create-modal"
    >
      <Box sx={{ width: "100%" }}>

        {/* LOADING  */}
        {loadingForm &&
          <>
            <div style={{backgroundColor:"transparent", width:"100%",maxWidth:"1170px", marginTop:"30px",marginBottom:"50px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
            
                <ProgressSpinner style={{width: '40px', height: '40px',marginRight: "20px",marginLeft:"20px"}} strokeWidth="4" />
                <div style={{fontSize:"16px",marginTop:"0px"}}> Carregando dados... </div>
                                        
            </div>
            
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            
          </>				
        }
        
        {/* CONTENT  */}
        {!loadingForm &&
        <>
        <div className="navigationContentWrapper flex-row justify-center align-items-start" style={{marginTop:"1rem", width:"100%", gap:"1rem"}}>
          
          {/* Coluna Esquerda: Formulário */}
          <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem", flex:1.1}}>
            <div className="resultsCard flex-column justify-center align-items-stretch w100" style={{gap:"1.5rem", padding:"2rem", borderRadius:"1.87rem", background:"#FFF"}}>

              {/* BLOCO 0 – Seleção de agência */}
              {selectCompany &&
              <>
              <div style={{fontWeight:600, fontSize:"1rem"}}>Selecione a agência</div>
                <Grid container spacing={3}>

                <Grid item xs={12} sm={6}>
                    <div className="field">
                    <label>Agência <span className="requiredField">*</span></label>
                    {/* Template no dropdown com companyName e abaixo em letras menores tradingName*/}
                    <Dropdown
                    value={selectedCompany}
                    onChange={(e) => setSelectedCompany(e.value)}
                    options={agenciasOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={loadingAgencias ? 'Carregando...' : 'Selecione a agência'}
                    className="w100"
                    disabled={loadingAgencias}
                    itemTemplate={(option) => (
                     <>
                      <div>
                        <div>{option.label}</div>
                        <small style={{color:'#555'}}>{option.subLabel}</small>
                      </div>
                      </>
                    )}
                    />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>                  
                </Grid>                
                </Grid>
                </>
              }         

              {/* BLOCO 1 – Dados da Pessoa */}
              <div style={{fontWeight:600, fontSize:"1rem"}}>Dados da Pessoa</div>
                <Grid container spacing={3}>

                {/* Nome + CPF na mesma linha */}
                <Grid item xs={12} sm={8}>
                    <div className="field">
                    <label>Nome completo <span className="requiredField">*</span></label>
                    <InputText
                        value={nomeCompleto}
                        onChange={(e)=>setNomeCompleto(e.target.value)}
                        className="w100"
                        placeholder="Nome e sobrenome"
                    />
                    </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <div className="field">
                    <label>CPF <span className="requiredField">*</span></label>
                    <InputMask
                        mask="999.999.999-99"
                        value={cpf}
                        onChange={(e)=>setCpf(e.value)}
                        className="w100"
                        placeholder="000.000.000-00"
                    />
                    </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <div className="field">
                    <label>Data de Nascimento <span className="requiredField">*</span></label>
                    <InputMask
                        mask="99/99/9999"
                        value={nascimento}
                        onChange={(e)=>setNascimento(e.value)}
                        className="w100"
                        placeholder="dd/mm/aaaa"
                    />
                    </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <div className="field">
                    <label>Telefone Celular <span className="requiredField">*</span></label>
                    <InputText
                        value={celular}
                        onChange={(e)=>setCelular(maskPhone(e.target.value))}
                        className="w100"
                        placeholder="(00) 00000-0000"
                    />
                    </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <div className="field">
                    <label>Grupo <span className="requiredField">*</span></label>
                    <Dropdown
                    value={pessoaGrupo}
                    onChange={(e) => setPessoaGrupo(e.value)}
                    options={pessoaGruposOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={loadingPessoaGrupos ? 'Carregando...' : 'Selecione o grupo'}
                    className="w100"
                    disabled={loadingPessoaGrupos}
                    />
                    </div>
                </Grid>
                </Grid>              

              {/* BLOCO 2 – Dados do Usuário */}
              <div style={{fontWeight:600, fontSize:"1rem", marginTop:"0.5rem"}}>Dados do Usuário</div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <div className="field">
                    <label>Setor (Perfil) <span className="requiredField">*</span></label>
                    {/* Perfil (Usuário) */}
                    <Dropdown
                    value={usuarioPerfil}
                    onChange={(e) => setUsuarioPerfil(e.value)}
                    options={usuarioPerfisOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={loadingUsuarioPerfis ? 'Carregando...' : 'Selecione o perfil'}
                    className="w100"
                    disabled={loadingUsuarioPerfis}
                    />
                    {loadingRights && <div style={{marginTop:8, display:'flex', alignItems:'center', gap:8}}>
                      <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="4" />
                      <small>Carregando direitos do perfil…</small>
                    </div>}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>                  
                </Grid>                

                <Grid item xs={12} sm={6}>
                  <div className="field">
                    <label>Email de login <span className="requiredField">*</span></label>
                    <InputText value={email} onChange={(e)=>setEmail(e.target.value)} className="w100" placeholder="nome@empresa.com" />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="field">
                    <label>Confirmação de email <span className="requiredField">*</span></label>
                    <InputText inputProps={{ autoComplete: 'off' }} autoComplete="off" id="emailConfirmation" value={email2} onChange={(e)=>setEmail2(e.target.value)} className="w100" placeholder="repita o e-mail" />
                  </div>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Checkbox
                        inputId="wantPasswordNow"
                        checked={wantPasswordNow}
                        onChange={(e) => {
                        setWantPasswordNow(e.checked);
                        if (!e.checked) { // limpamos os campos se desabilitar
                            setSenha('');
                            setSenha2('');
                        }
                        }}
                    />
                    <label htmlFor="wantPasswordNow" style={{ marginLeft: 8 }}>
                        Quero definir uma senha para o usuário
                    </label>
                    <div style={{ fontSize: 12, color: '#777', marginTop: 4 }}>
                        Comportamento padrão: Ao cadastrar será enviado um link para o e-mail informado para definição de senha.
                    </div>
                </Grid>

                {wantPasswordNow && (
                <>
                    <Grid item xs={12} sm={6}>
                    <div className="field">
                        <label>Senha <span className="requiredField">*</span></label>
                        <Password
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        toggleMask
                        feedback
                        placeholder="Digite sua senha (mín. 8 caracteres)"
                        autoComplete="new-password"
                        className="w100"
                        weakLabel="Fraca"
                        mediumLabel="Média"
                        strongLabel="Forte"
                        promptLabel="Digite uma senha"
                        maxLength={20}
                        header={<h6>Características de uma senha forte</h6>}
                        footer={
                            <ul style={{ lineHeight: 1.5, marginLeft: '1.5rem' }}>
                            <li>Pelo menos 8 caracteres</li>
                            <li>Máx de 20 caracteres</li>
                            <li>Inclua letras maiúsculas e minúsculas</li>
                            <li>Adicione números</li>
                            <li>Use ao menos um símbolo (ex: !, @, #, $)</li>
                            </ul>
                        }
                        />
                    </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                    <div className="field">
                        <label>Confirmação de senha <span className="requiredField">*</span></label>
                        <Password
                        id="passwordConfirmation"
                        value={senha2}
                        onChange={(e)=>setSenha2(e.target.value)}
                        className="w100"
                        toggleMask
                        feedback={false}
                        placeholder="repita a senha"
                        />
                    </div>
                    </Grid>
                </>
                )}

              </Grid>

              {/* BLOCO 3 – Direitos individuais */}
              <div style={{fontWeight:600, fontSize:"1rem", marginTop:"0.5rem"}}>Direitos e restrições especiais</div>
              <Grid container spacing={2}>

                {/* Só exibe se o usuário logado tiver esse direito */}
                {userRights.includes('manageUsers') && (
                <Grid item xs={12} sm={12}>
                  <div className="flex-row" style={{gap:"10px", alignItems:'center'}}>
                    <Checkbox inputId="manageAgencyUsers" checked={rightsCustom.manageAgencyUsers} onChange={(e)=>setRightsCustom(v=>({...v, manageAgencyUsers: e.checked}))} />
                    <label htmlFor="manageAgencyUsers">Gerenciar usuários da agência</label>
                  </div>
                </Grid>)}

                <Grid item xs={12} sm={12}>
                  <div className="flex-row" style={{gap:"10px", alignItems:'center'}}>
                    <Checkbox inputId="seeOwnReservationsOnly" checked={rightsCustom.seeOwnReservationsOnly} onChange={(e)=>setRightsCustom(v=>({...v, seeOwnReservationsOnly: e.checked}))} />
                    <label htmlFor="seeOwnReservationsOnly">Visualizar apenas as próprias reservas</label>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>

          {/* Coluna Direita: Direitos do grupo selecionado */}
          <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem", flex:0.6, alignSelf:'stretch',justifyContent:'flex-start'}}>
            <div className="resultsCard flex-column justify-start align-items-stretch w100" style={{gap:"0.75rem", padding:"1.5rem", borderRadius:"1.87rem", background:"#FFF",position:'sticky',top:'10px'}}>
              <div style={{fontWeight:600, fontSize:"1rem"}}>Direitos do grupo {usuarioPerfil ? usuarioPerfil.name : ''} / perfil do usuário</div>
              {!usuarioPerfil && <small style={{color:"#777"}}>Selecione um grupo / perfil (Gestão, Administrativo, Operacional ou Comercial) para visualizar os direitos vinculados.</small>}
              {usuarioPerfil && !loadingRights && (
                <ul style={{margin:0, paddingLeft:'1.1rem'}}>
                  {Array.isArray(direitosDoPerfil) && direitosDoPerfil.length > 0 ? direitosDoPerfil.map((d,i)=>(
                    <li key={i} style={{lineHeight:'1.6rem'}}>{typeof d === 'string' ? d : (d?.label || d?.label || 'Direito')}</li>
                  )) : <small style={{color:"#777"}}>Nenhum direito retornado para este grupo.</small>}
                </ul>
              )}
            </div>
          </div>

        </div>
        </>}


      </Box>

      <Toast ref={toast} position="bottom-center" />
    </Dialog>
  );
};

const mapStateToProps = (store) => ({
  dialog: store.appReducer.dialog,
  masterUser: store.appReducer.masterUser,
  userRights: store.appReducer.userRights
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...UserActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserCreateModal);
